// Copy to clipboard: a button with data-n-copy="text" copies that text; data-copy-target="id"
// copies the value or text of the element with that id (the older deploy-page contract).
import { $ } from './dom';
import { showToast } from './toast';

export function initCopy(): void {
	document.addEventListener('click', async (e) => {
		const button = (e.target as Element).closest<HTMLElement>('[data-n-copy], [data-copy-target]');
		if (!button) return;
		const target = button.dataset.copyTarget ? $<HTMLInputElement>(`#${button.dataset.copyTarget}`) : null;
		const text = button.dataset.nCopy ?? (target ? (target.value ?? target.textContent ?? '') : '');
		try {
			await navigator.clipboard.writeText(text.trim());
			showToast(button.dataset.copyMessage ?? 'Copied', 'success', { duration: 1800 });
		} catch {
			showToast('Could not copy. Select the text and copy it by hand.', 'error');
		}
	});
}
